import { Button } from 'components/button/Button';
import { DropdownTrigger } from 'components/dropdown/DropdownTrigger';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const TriggerButton = styled(DropdownTrigger)`
    color: ${tokens.text.secondary};

    &:hover {
        background-color: var(--action-hover);
        color: ${tokens.text.primary};
    }
`;

export const SelectionActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.4rem;
    margin-top: 0.4rem;
`;

export const SelectionActionButton = styled(Button)`
    font-size: 1.2rem;
    color: ${tokens.text.link};
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.2rem 0.4rem;
    white-space: nowrap;

    &:hover:not(:disabled) {
        color: ${tokens.text.primary};
    }
`;

export const PopupContent = styled.div`
    width: 32rem;
    max-height: 40rem;
    display: flex;
    flex-direction: column;
`;

export const TreeContainer = styled.div`
    overflow-y: auto;
    padding: 0.8rem;
    flex: 1;
    min-height: 0;
`;

export const CorpRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0;
    font-weight: 500;
`;

export const CorpExpandButton = styled(Button)`
    padding: 0.2rem 0.4rem;
    font-size: 1rem;
    color: ${tokens.text.secondary};
    flex-shrink: 0;
`;

export const LocationRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.2rem 0 0.2rem 4rem;
    cursor: pointer;
    & label {
        cursor: pointer;
    }
    & label:hover {
        background: ${tokens.action.hover};
    }
`;

export const SearchWrapper = styled.div`
    padding: 0.8rem;
    border-bottom: 1px solid ${tokens.border.default};
`;

export const SectionLabel = styled.div`
    font-size: 1.1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${tokens.text.secondary};
    padding: 0.8rem 0 0.2rem;
`;

export const SectionDivider = styled.hr`
    border: none;
    border-top: 1px solid ${tokens.border.default};
    margin: 0.6rem 0;
`;
